// Generate structured data (Schema.org JSON-LD) for SEO

export const generateOrganizationSchema = () => {
  const baseUrl = 'https://georgedives.com';
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "George Dives",
    "url": baseUrl,
    "logo": {
      "@type": "ImageObject",
      "url": `${baseUrl}/george-dives-logo.png`,
      "width": "512",
      "height": "512"
    },
    "image": `${baseUrl}/og-image.jpg`,
    "description": "Professional dive instructor offering PADI courses, dive packages, and underwater adventures worldwide",
    "sameAs": [
      "https://www.instagram.com/george_dives",
      "https://www.facebook.com/share/1Q8HzKKNWL/"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "email": "info@georgedives.com",
      "telephone": "+30-698-794-6278",
      "availableLanguage": ["English"]
    }
  };
};

export const generatePersonSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "George",
    "jobTitle": "Professional Dive Instructor",
    "description": "PADI certified dive instructor with years of experience teaching diving and leading underwater adventures around the world",
    "knowsAbout": [
      "Scuba Diving",
      "PADI Certification",
      "Underwater Photography",
      "Dive Safety",
      "Marine Life"
    ],
    "sameAs": [
      "https://instagram.com/george_dives"
    ]
  };
};

export const generateLocalBusinessSchema = (location) => {
  if (!location) return null;
  
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": `George Dives - ${location.location}`,
    "description": location.description || "Professional diving services and PADI courses",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": location.location,
      "addressCountry": location.country
    },
    "geo": location.coordinates ? {
      "@type": "GeoCoordinates",
      "latitude": location.coordinates.lat,
      "longitude": location.coordinates.lng
    } : undefined,
    "openingHours": "Mo-Su 08:00-18:00",
    "priceRange": "$$",
    "image": location.image_url
  };
};

export const generateCourseSchema = (course) => {
  return {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": course.name,
    "description": course.description,
    "provider": {
      "@type": "Organization",
      "name": "George Dives",
      "sameAs": "https://instagram.com/george_dives"
    },
    "courseCode": course.id,
    "hasCourseInstance": {
      "@type": "CourseInstance",
      "courseMode": "in-person",
      "instructor": {
        "@type": "Person",
        "name": "George"
      }
    },
    "offers": course.price ? {
      "@type": "Offer",
      "price": course.price,
      "priceCurrency": "EUR"
    } : undefined
  };
};

export const generateBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};

export const generateTouristAttractionSchema = (location) => {
  if (!location) return null;
  
  return {
    "@context": "https://schema.org",
    "@type": "TouristAttraction",
    "name": `Scuba Diving in ${location.location}`,
    "description": `Experience world-class scuba diving and PADI courses in ${location.location}, ${location.country}`,
    "touristType": ["Adventure Seekers", "Water Sports Enthusiasts", "Nature Lovers"],
    "address": {
      "@type": "PostalAddress",
      "addressLocality": location.location,
      "addressCountry": location.country
    }
  };
};

export const generateWebPageSchema = (pageName, pageUrl) => {
  const baseUrl = 'https://georgedives.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": pageName,
    "url": `${baseUrl}${pageUrl}`,
    "isPartOf": {
      "@type": "WebSite",
      "name": "George Dives",
      "url": baseUrl
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": baseUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": pageName,
          "item": `${baseUrl}${pageUrl}`
        }
      ]
    }
  };
};

export const generateWebSiteSchema = () => {
  const baseUrl = 'https://georgedives.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "George Dives",
    "alternateName": "George Dives - Professional Dive Instructor",
    "url": baseUrl,
    "description": "Professional dive instructor offering PADI courses, dive packages, and underwater adventures worldwide",
    "inLanguage": "en"
  };
};
